<template>
  <div class="sensitive-content">
    <div class="mb-3">
      <p class="mb-1 fw-semibold">This content is marked as sensitive</p>
      <p v-if="description" class="text-muted small" data-test="sensitive-description">{{ description }}</p>
    </div>

    <div class="d-flex align-items-center gap-2">
      <AppButton
        type="button"
        :disabled="submitting"
        :loading="submitting"
        customClass="w-100"
        ignore-plan-restriction
        @buttonClick="confirm"
      >
        I understand
      </AppButton>
    </div>

    <p v-if="error" class="text-danger mt-2">{{ error }}</p>
  </div>
</template>
<script>
import AppButton from '@/Components/AppButton.vue';

export default {
  name: 'SensitiveContent',
  components: { AppButton },
  props: {
    linkId: { type: [Number, String], required: true },
    // Optional description. Can be passed from description_sensitive_content field when available
    description: { type: String, default: '' }
  },
  emits: ['success', 'failure'],
  data() {
    return {
      submitting: false,
      error: ''
    };
  },
  methods: {
    async confirm() {
      this.error = '';
      try {
        this.submitting = true;
        const url = typeof route === 'function' && route().has('link.unlock')
          ? route('link.unlock')
          : '/link/unlock';

        const res = await axios.post(url, {
          link_id: this.linkId,
          step: 3,
          input: true
        });

        const ok = !!(res && res.data && res.data.success === true);
        if (ok) {
          this.$emit('success', true);
        } else {
          this.error = (res && res.data && res.data.message) || 'Unable to proceed.';
          this.$emit('failure');
        }
      } catch (e) {
        this.error = 'Unable to proceed at the moment. Please try again.';
        this.$emit('failure');
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>
<style scoped>
.sensitive-content {
  padding: 4px;
}
</style>
